/* ANBE - "Combínalo con" en el carrito: añadir talla con un clic */
(function () {
  'use strict';
  if (window.__anbeUpsell) return;
  window.__anbeUpsell = true;

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-anbe-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    const box = btn.closest('[data-anbe-upsell]');
    const msg = box && box.querySelector('.anbe-upsell__msg');
    if (msg) msg.textContent = '';
    btn.classList.add('is-loading');

    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.anbeUpsellAdd), quantity: 1 }] })
    })
      .then(r => r.json().then(data => ({ ok: r.ok, data })))
      .then(({ ok, data }) => {
        if (!ok) throw new Error(data.description || data.message || 'No se ha podido añadir');
        const drawer = document.querySelector('m-cart-drawer');
        if (drawer && typeof drawer.onCartDrawerUpdate === 'function') {
          drawer.onCartDrawerUpdate(true); // repinta productos, subtotal y este bloque
        } else {
          window.location.reload();
        }
        try {
          if (window.MinimogEvents && window.MinimogTheme) {
            MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { source: 'anbe-upsell' });
          }
        } catch (err) {}
      })
      .catch(err => {
        btn.classList.remove('is-loading');
        if (msg) msg.textContent = err.message;
      });
  }, true);
})();
